<template>
  <div class="relative flex flex-col items-center pointer-events-none select-none" style="gap: 14px;">
    <div class="flex items-center gap-2">
      <div v-for="(icon, index) in platformIcons" :key="`mcp-platform-${index}`"
      class="w-8 h-8 flex items-center justify-center rounded-md border border-border-normal">
        <img :src="icon">
      </div>
    </div>
    <div class="w-max flex items-center gap-1 pl-1.5 pr-2 py-1 bg-white z-10 rounded-md border border-border-normal">
      <MCPIcon class="text-icon-muted" />
      <BaseText type="label" size="sm" class="text-text-muted">
        MCP
      </BaseText>
    </div>
    <!-- Connector Decoration -->
    <svg class="decoration left" xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 28 30" fill="none">
      <path d="M0.5 0V21C0.5 25.4183 4.08172 29 8.5 29H27.5" stroke="#ECEFF3"/>
    </svg>
    <svg class="decoration center-left" xmlns="http://www.w3.org/2000/svg" width="21" height="14" viewBox="0 0 21 14" fill="none">
      <path d="M0.5 0C0.5 3.86599 3.63401 7 7.5 7H13.5C17.366 7 20.5 10.134 20.5 14" stroke="#ECEFF3"/>
    </svg>
    <svg class="decoration center-right" xmlns="http://www.w3.org/2000/svg" width="21" height="14" viewBox="0 0 21 14" fill="none">
      <path d="M20.5 0C20.5 3.86599 17.366 7 13.5 7H7.5C3.63401 7 0.5 10.134 0.5 14" stroke="#ECEFF3"/>
    </svg>
    <svg class="decoration right" xmlns="http://www.w3.org/2000/svg" width="24" height="30" viewBox="0 0 24 30" fill="none">
      <path d="M23 0V21C23 25.4183 19.4183 29 15 29H0" stroke="#ECEFF3"/>
    </svg>
  </div>
</template>

<script>
import MCPIcon from './MCPIcon.vue'

export default {
  name: 'MCPDecoration',
  components: {
    MCPIcon
  },
  data () {
    return {
      platformIcons: [
        require('@/assets/icons/mcp-platforms/claude.svg'),
        require('@/assets/icons/mcp-platforms/grok.svg'),
        require('@/assets/icons/mcp-platforms/gemini.svg'),
        require('@/assets/icons/mcp-platforms/chatgpt.svg')
      ]
    }
  }
}
</script>

<style scoped>
.decoration {
  position: absolute;
}
.decoration.left {
  top: 32px;
  left: 16px;
}
.decoration.center-left {
  top: 32px;
  left: 56px;
}
.decoration.center-right {
  top: 32px;
  right: 54px;
}
.decoration.right {
  top: 32px;
  right: 16px;
}
</style>